import { Typography } from "@mui/material";
import styles from "./Home.module.css";
import Stack from '@mui/material/Stack';

export default function Home() {
    return (
        <div className={styles.container}>
            <Stack 
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={1}
            >
                <Typography variant="h2" color="rgba(255, 255, 255, 87)">Hello!</Typography>
                <Typography variant="h3" color="#03a9f4">I'm Zhong Han</Typography>
                <Typography variant="h4" color="rgba(255, 255, 255, 87)">Nice to meet you!</Typography>
            </Stack>
        </div>
    );
}